/**
 * @author Fernando FH
 */

 import PRM from "@/core/PermissionConstants";
 import  RouteConstants  from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.TELEMEDICINE_PAGINATION_HISTORY.path,
  name: RouteConstants.TELEMEDICINE_PAGINATION_HISTORY.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/TelemedicineHistoryService"),
    table: () =>  import("@/app/components/telemedicine/history/TelemedicineHistoryTable"),
    form: () =>  import("@/app/components/telemedicine/history/TelemedicineHistoryForm"),
    header: {
      icono: "mdi-monitor-dashboard",
      texto: "Historial de atenciones | Telemedicina Historial",
      textNew: "Atender  | Telemedicina Historial",
      textEdit: "Editar  | Telemedicina Historial",
      textView: "Visualizar  | Telemedicina Historial"
    },
    prm: PRM.MODULE_TELEMEDICINE_HISTORY,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    labelDate: "Seleccione fecha",
    namePDF: "Telemedicina",
    module: "telemedicina"
  },
};
